import { render, staticRenderFns } from "./_comment.vue?vue&type=template&id=3fccc569"
import script from "./_comment.vue?vue&type=script&lang=js"
export * from "./_comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports